import React from 'react';
const Pattern = () => {
  return (
    <div style={{textAlign:'center',margin:'50px auto',maxWidth:'1000px'}}>
      <h1 style={{fontSize: '24px',color:'#ADFF2F'}}>🚧 We are diligently working on creating the best content for you! Please bear with us as we strive to provide you with valuable and engaging information. Your support and patience are highly appreciated! Stay tuned for exciting updates as we continue to enhance our website. Thank you for being a part of our journey! 🚀</h1>
    </div>
  )
}

export default Pattern;
